/*
   For **source** type filters, add a data source in the src\components\BulkUpdateTasksModal\BulkUpdateDataHelper.jsx file
*/
import { FilterSelectorColumnTypes as types } from "@etframework/ui.components";
export const ColumnSettings = {
  Name: {
    field: "Name",
    type: types.source,
    displayProperty: "Name",
    headerText: "Name",
    OData: {
      isLiteral: true,
    },
  },
  Client: {
    field: "ClientId",
    type: types.source,
    displayProperty: "FullName",
    headerText: "Client",
  },
  Stage: {
    field: "Stage.Order",
    type: types.source,
    displayProperty: "Title",
    headerText: "Stage",
  },
  Tags: {
    field: "Tags.Id",
    type: types.source,
    displayProperty: "Title",
    headerText: "Tags",
    OData: {
      isCollection: true,
    },
  },
  DueDate: {
    field: "DueDate",
    id: "single",
    type: types.date,
    headerText: "DueDate",
    dateFormat: "MM/dd/yyyy",
  },
  DueDateRange: {
    field: "DueDate",
    id: "range",
    type: types.dateRange,
    headerText: "DueDateRange",
    dateFormat: "MM/dd/yyyy",
  },
  StartDate: {
    field: "StartDate",
    id: "single",
    type: types.date,
    headerText: "StartDate",
    dateFormat: "MM/dd/yyyy",
  },
  StartDateRange: {
    field: "StartDate",
    id: "range",
    type: types.dateRange,
    headerText: "StartDateRange",
    dateFormat: "MM/dd/yyyy",
  },
  AutoRollover: {
    field: "AutoRollover",
    type: types.boolean,
    headerText: "AutoRollover",
  },
  TaxDeadlineExtension: {
    field: "TaskTaxReturnInfo.ExtendedTaxDeadline",
    type: types.boolean,
    headerText: "TaxDeadlineExtension",
  },
  Assignee: {
    field: "AssigneeId",
    type: types.source,
    displayProperty: "FullName",
    headerText: "Assignee",
  },
  Collaborators: {
    field: "Collaborators.UserId",
    type: types.source,
    displayProperty: "FullName",
    headerText: "Collaborators",
    OData: {
      isCollection: true,
    },
  },
  Template: {
    field: "TemplateId",
    type: types.source,
    displayProperty: "Name",
    headerText: "Template",
  },
  TaxYear: {
    field: "TaskTaxReturnInfo.TaxYear",
    type: types.source,
    displayProperty: "Year",
    headerText: "TaxYear",
  },
  TaxDeadline: {
    field: "TaskTaxReturnInfo.TaxDeadline",
    id: "single",
    type: types.date,
    headerText: "TaxDeadline",
    dateFormat: "MM/dd/yyyy",
  },
  TaxDeadlineRange: {
    field: "TaskTaxReturnInfo.TaxDeadline",
    id: "range",
    type: types.dateRange,
    headerText: "TaxDeadlineRange",
    dateFormat: "MM/dd/yyyy",
  },
  TaskType: {
    field: "TaskTypeId",
    type: types.source,
    displayProperty: "Title",
    headerText: "TaskType",
  },
  FilingStatus: {
    field: "TaskTaxReturnInfo.FilingStatus",
    type: types.source,
    displayProperty: "Title",
    headerText: "FilingStatus",
    OData: {
      // isLiteral: true
      namespace:
        "ET.DueDates.Models.Entities.Infrastructure.Enums.FilingStatus",
    },
  },
  UpdatedDate: {
    field: "UpdatedDate",
    type: types.date,
    headerText: "UpdatedDate",
  },
};
